<script>
import { mapState } from 'vuex'
import ApiAutomationDetail from '@/components/api-automation/ApiAutomationDetail'
import ListView from '@/components/common/ListView'

export default {
  data() {
    return {
      title: 'API Automation List',
      searchAttributes: ['name', 'hexId'],
      selectedApiAutomation: null,
      toolbarButtons: null
    }
  },

  watch: {
    selectedApiAutomation() {
      this.routeEdit()
    }
  },

  computed: {
    ...mapState({
      apiAutomations: state => state.apiAutomation.apiAutomations
    })
  },

  methods: {
    create: function() {
      this.$router
        .push({
          name: 'api-automation-designer',
          params: { apiAutomationParam: null }
        })
        .catch() // Todo: Correct URL
    },
    routeEdit: function() {
      if (this.selectedApiAutomation) {
        this.$router
          .replace({
            name: 'api-automation-detail',
            params: { hexId: this.selectedApiAutomation.hexId }
          })
          .catch() // Todo: Correct URL
      } else {
        this.$router.replace({ name: 'api-automation-list' }).catch()
      }
    },
    buttonsInit: function(buttons) {
      this.toolbarButtons = buttons
    }
  },

  created() {
    this.$store.dispatch('fetchApiAutomations').then(apiAutomations => {
      if (this.$route.name === 'workflow-detail') {
        this.selectedApiAutomation = apiAutomations.find(apiAutomation => {
          return apiAutomation.hexId === this.$route.params.hexId
        }, this)
      }
    }, this)
  },

  components: {
    ApiAutomationDetail,
    ListView
  }
}
</script>

<template>
  <list-view
    search
    :items="apiAutomations"
    title="API Automations"
    :search-attributes="searchAttributes"
    create-action
    item-key="hexId"
    @create="create"
    v-model="selectedApiAutomation"
  >
    <template slot="list-toolbar-button">
      <v-btn
        v-for="(button, i) in toolbarButtons"
        :key="i"
        icon
        accent
        @click="button.method()"
      >
        <v-icon>{{ button.icon }}</v-icon>
      </v-btn>
    </template>
    <template slot="list-item" slot-scope="slotProps">
      <v-list-tile-avatar>
        <vue-letter-avatar
          :name="slotProps.item.apiAutomationName"
          size="40"
          :rounded="true"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          v-text="slotProps.item.apiAutomationName"
        ></v-list-tile-title>
        <v-list-tile-sub-title
          v-html="slotProps.item.apiAutomationDescription"
        ></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <api-automation-detail
      slot="list-item-detail"
      slot-scope="slotProps"
      v-if="slotProps.item != null"
      :api-automation="slotProps.item"
    ></api-automation-detail>
  </list-view>
</template>
